import { render, staticRenderFns } from "./Slide1.vue?vue&type=template&id=071b949e&scoped=true&"
import script from "./Slide1.vue?vue&type=script&lang=js&"
export * from "./Slide1.vue?vue&type=script&lang=js&"
import style0 from "./Slide1.vue?vue&type=style&index=0&id=071b949e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "071b949e",
  null
  
)

export default component.exports